import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import OrderSuccess from "@/pages/OrderSuccess";

export const Route = createFileRoute("/_public/order/success")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Deposit Received \u2014 Modern Fence Install", "Your fence install deposit has been received. We'll confirm your install date shortly.", "/order/success", true),
  component: OrderSuccess,
});
